module.exports = __webpack_public_path__ + "img/jinrong.6be481b1.png";